import { render, staticRenderFns } from "./company-history.vue?vue&type=template&id=c4b5bc40&"
import script from "./company-history.vue?vue&type=script&lang=js&"
export * from "./company-history.vue?vue&type=script&lang=js&"
import style0 from "./company-history.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports